import { render, staticRenderFns } from "./ColumnTransactionStatusTefGsurf.vue?vue&type=template&id=dffaf6d2&scoped=true"
import script from "./ColumnTransactionStatusTefGsurf.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusTefGsurf.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusTefGsurf.vue?vue&type=style&index=0&id=dffaf6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffaf6d2",
  null
  
)

export default component.exports